<template>
    <div class="Man-RequisicaoPrincipal">
        <PageTitle icon="fa fa-gear" main="Requisição"
            sub="Estoque Requisições" />
        <div class="Man-RequisicaoPrincipal">
            <b-card no-body>
                <b-tabs>                                        
                    <b-tab title="Requisição" active><RequisicaoLancamento /></b-tab>                                                                                                                        
                    <b-tab title="Indicadores" ><RequisicaoPainel /></b-tab>                                                                                                                                           
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import RequisicaoLancamento from '../estoque/RequisicaoLancamento'
import RequisicaoPainel from '../estoque/RequisicaoPainel'


export default {
    name: 'RequisicaoPrincipal',    
    components: { PageTitle, RequisicaoLancamento, RequisicaoPainel}
    
}
</script>

<style>

</style>






